import {library} from '@fortawesome/fontawesome-svg-core';
import {faTachometerAlt, faAngleLeft, faAngleRight, faBars} from '@fortawesome/free-solid-svg-icons';
import {faCalendarAlt, faEdit} from '@fortawesome/free-regular-svg-icons';

library.add(faTachometerAlt, faCalendarAlt, faAngleLeft, faAngleRight, faBars, faEdit);
